import React from "react";
import {withRouter} from "react-router-dom";
import {LayoutWithHeader} from "../components/LayoutWithHeader";
import {useAuth} from "../contexts/auth";

const FeedbackInner = () => {
	const authContext = useAuth()
	return (
		<>
			<LayoutWithHeader title={"Feedback"}>
				<div>Not Implemented Yet.</div>
			</LayoutWithHeader>
		</>
	)
}


export const Feedback = withRouter(FeedbackInner);